import { render } from "./StudiesUploadHistory.vue?vue&type=template&id=6e1b66be&scoped=true"
import script from "./StudiesUploadHistory.vue?vue&type=script&lang=js"
export * from "./StudiesUploadHistory.vue?vue&type=script&lang=js"

import "./StudiesUploadHistory.vue?vue&type=style&index=0&id=6e1b66be&lang=scss"
import "./StudiesUploadHistory.vue?vue&type=style&index=1&id=6e1b66be&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e1b66be"]])

export default __exports__